import React from 'react';
import '../styles/Hero.css';

function Hero() {
  return (
    <section className="hero" data-aos="fade-up">
      <h1>Hi, I'm the Network Slayer.</h1>
      <p>I design secure and scalable IT infrastructure for businesses.</p>
      <a href="#projects" className="cta-button">View My Work</a>
    </section>
  );
}

export default Hero;